export default __webpack_public_path__ + "static/media/integrate~BBONpOlP.92502d73.svg";